
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"192","height":"112","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"opacity":".1","fill-rule":"evenodd","clip-rule":"evenodd","d":"M10.045 0A5872.12 5872.12 0 004.56 5.54C3.215 6.9 2.276 8.666 1.336 10.43.904 11.243.472 12.056 0 12.828v4.012c1.189 4.258 4.16 7.2 7.153 10.162l.807.803a65445.892 65445.892 0 0138.688 38.667c8.56 8.56 17.12 17.121 25.684 25.679a3517.973 3517.973 0 0015.132 15.002c5.133 5.062 12.36 5.198 17.463.105a48421.06 48421.06 0 0083.331-83.326c4.871-4.887 4.952-11.712.442-16.945-.659-.766-1.374-1.481-2.089-2.196l-.161-.16L181.818 0h-52.166l.282.287c1.115 1.13 2.149 1.552 3.746 1.22 7.775-1.612 15.489 3.4 17.332 11.145 1.793 7.558-2.807 15.524-10.311 17.694-5.534 1.602-10.446.286-14.559-3.657-4.069-3.896-5.239-8.733-4.149-14.228.186-.924.201-2.32-.347-2.883A815.572 815.572 0 00112.183 0h-8.876l-.001 9.522c.001 10.144.002 20.288-.041 30.437-.01 1.943.562 3.133 2.21 4.314 5.258 3.771 7.222 10.712 5.047 16.754-2.169 6.007-8.051 10.1-14.269 9.935-6.624-.191-12.33-4.576-14.092-10.849-1.763-6.288.592-12.968 6.167-16.383 1.96-1.2 2.391-2.526 2.381-4.61-.06-13.04-.062-26.082-.028-39.12H10.045z","fill":"#0F8190"}})])
          )
        }
      }
    